import { Component, OnInit, Input, Inject, ViewChild, Output, EventEmitter } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';
import { Observable } from 'rxjs';
import { MULTIFACILITY_DEFERRED_ADMISSION, MULTIFACILITY_PHASE2 } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import {
  ReferralAction, actionStateLabel, facilityStateLine, facilityAlreadyIn, facilityAlreadyHint,
  facilitiesAlreadyIn, facilitiesAlreadyText, rowStateLabel,
  ResidentOfficeOption, residentOfficeOptions, facilitiesWithoutResidentOffice
} from 'src/app/middleware/common/referralDialog/facility-state';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';



@Component({
  selector: 'app-acceptReferral',
  templateUrl: './acceptReferral.component.html',
  styleUrls: ['./acceptReferral.component.scss']
})

export class AcceptReferralComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;

  OfficeIDList: any = [];
  myOfficeID: any;
  spinner: boolean = false;

  menuModulesList: any = [] = [];
  folderID: number = 0;
  showAddButton: boolean = false;

  attachedToCoreList: any = [] = [];
  roleIdList: any = [];
  CorefolderID: number = 0;
  showNoRecordFound: boolean = false;
  referralName: string = "";
  documentId: number = 0;

  showAddCore: boolean = false;
  searchName: string = '';
  Module: string = '';
  isShare: false;
  mainModuleName: string = '';
  systemFeildsList: any = ([] = []);
  showDetail: boolean = false;
  vieworUpdate: string = "";
  mainModuleNameForDetails: string = "";
  transactionID: number = 0;
  CoreShowName: string = "";
  modulenameUpdate: string = "";
  referralD: number = 0;
  personName:string="";
  textForPerson:string="";

  constructor(private dialog: MatDialog, private dialog1: MatDialog, private datePipe: DatePipe, public dialogRef: MatDialogRef<AcceptReferralComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService, private loaderService: LoaderService,
    private formsService: FormsService) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }

  ngOnInit(): void {
    var SelectedCore = [];
    SelectedCore = this.menuModulesList.filter((x) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
      this.folderID = SelectedCore[0].folderID;
      this.modulenameUpdate = "Update " + this.CoreShowName;
    }
    this.showAddButton = true;
    this.documentId = this.data.documentID;
    this.referralName = this.data.name;
    this.referralD = this.data.referralD;
    this.attachedToCoreList = this.data.coreList;
    this.vieworUpdate = "View";

    this.personName=this.data.name;
    //this.textForPerson = `We are pleased to inform you that ${this.personName} has been officially accepted.`;
    this.textForPerson = `We are pleased to inform you that <b>${this.personName}</b> has been officially <b>accepted</b>.`;

    // Facility picker (same as the plain Accept dialog, 2026-09-25): multi-recipient
    // portal referrals choose WHO this Accept is for. Nothing is pre-selected except
    // a per-site action from the Recipients panel.
    const fac = this.data.selectedRecord?.sharedFacilities || [];
    if (this.mfPhase2 && this.data.selectedRecord?.isExternal && fac.length > 1) {
      this.providerOptions = fac;
      if (this.data.preselectProviderKey) {
        this.selectedProviderKeys[this.data.preselectProviderKey] = true;
      }
      const opts = this.residentOffices();   // default resident office for a preselected facility
      this.residentOfficeID = opts.length ? opts[0].officeID : 0;
    }

    if (this.data.selectedRecord.emails) {
      let emailList = this.data.selectedRecord.emails.split(',');
      emailList.forEach((email: string) => {
        email = email.trim();
        if (email !== "") {
          let toArray = email.split("@");
          let shortName = toArray[0].match(/\b(\w)/g)?.join('') || '';
          var obj = {
            name: "",
            email: email,
            img: "",
            shortName: shortName
          };
          this.addUpdateParticipantList.push(obj);
        }
      });

      // Reset input
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      if (this.addUpdateParticipantList.length > 0) {
        this.showAddButton = false;
        this.textButton = "FollowUp & Send Mail";
      } else {
        this.showAddButton = true;
      }
    }
    this.getFileManagerDetails();
  }

  close() {
    this.dialogRef.close();
  }

  // ── Facility picker + facility state (shared behaviour with the plain Accept dialog) ──
  mfPhase2 = MULTIFACILITY_PHASE2;
  readonly action: ReferralAction = 'accept';
  providerOptions: any[] = [];
  selectedProviderKeys: { [key: string]: boolean } = {};
  provKey(f: any): string { return (f.providerAdmissionRequestId || '') + '|' + (f.facilityName || ''); }
  actionLabel(): string { return actionStateLabel(this.action); }
  stateLine(f: any): string { return facilityStateLine(f); }
  alreadyIn(f: any): boolean { return facilityAlreadyIn(f, this.action); }
  alreadyList(): any[] { return facilitiesAlreadyIn(this.providerOptions, this.action); }
  alreadyText(): string { return facilitiesAlreadyText(this.providerOptions, this.action); }
  allAlready(): boolean { return this.providerOptions.length > 0 && this.alreadyList().length === this.providerOptions.length; }
  rowState(): string { return rowStateLabel(this.data?.selectedRecord); }
  providerDisabled(f: any): boolean {
    return f?.canAct === false || this.alreadyIn(f) || (!f.isMine && !f.providerAdmissionRequestId);
  }
  providerHint(f: any): string {
    if (f?.canAct === false) return 'You do not have access to this facility\'s office';
    if (this.alreadyIn(f)) return facilityAlreadyHint(f, this.action);
    return this.providerDisabled(f) ? 'Sync this referral again to enable responding for this facility' : '';
  }
  selectedProviders(): any[] {
    return this.providerOptions.filter((f: any) => this.selectedProviderKeys[this.provKey(f)]);
  }
  canSubmitProviders(): boolean {
    return !this.providerOptions.length || (this.selectedProviders().length > 0 && !this.allAlready());
  }
  ownSelected(): boolean {
    return !this.providerOptions.length || this.selectedProviders().some((f: any) => !!f.isMine);
  }
  // Only OTHER facilities selected: the Accept goes out on their behalf and no
  // resident is linked/created in this office (only "Accept only" is offered).
  onBehalfOfOthersOnly(): boolean {
    return this.providerOptions.length > 0 && this.selectedProviders().length > 0 && !this.ownSelected();
  }
  private targetProviders(): any[] | null {
    return this.providerOptions.length
      ? this.selectedProviders().map((f: any) => ({
          providerAdmissionRequestId: '' + (f.providerAdmissionRequestId || ''),
          providerId: '' + (f.providerId || ''),
          facilityName: f.facilityName || '',
          isMine: !!f.isMine
        }))
      : null;
  }
  // ── Resident office (2026-09-25): WHICH office the new resident is created in —
  // one of the selected facilities' mapped offices the user can work in. When it
  // is another office, the accept goes out without a resident and the new
  // resident is attached to that facility afterwards (AttachResidentToReferral).
  residentOfficeID = 0;
  residentOffices(): ResidentOfficeOption[] { return residentOfficeOptions(this.selectedProviders(), Number(this.myOfficeID)); }
  residentOfficesMissing(): any[] { return facilitiesWithoutResidentOffice(this.selectedProviders(), Number(this.myOfficeID)); }
  onProviderToggle(f: any, checked: boolean) {
    this.selectedProviderKeys[this.provKey(f)] = checked;
    const opts = this.residentOffices();
    if (!opts.some(o => o.officeID === this.residentOfficeID)) this.residentOfficeID = opts.length ? opts[0].officeID : 0;
  }
  residentOfficeName(): string {
    const o = this.residentOffices().find(x => x.officeID === this.residentOfficeID);
    return o ? o.officeName : '';
  }
  residentFacilityName(): string {
    const o = this.residentOffices().find(x => x.officeID === this.residentOfficeID);
    return o ? o.facilityName : '';
  }
  // Office the resident FORM must create the resident in (0 = this office).
  residentTargetOffice(): number {
    return this.providerOptions.length && this.residentOfficeID && this.residentOfficeID !== Number(this.myOfficeID)
      ? this.residentOfficeID : 0;
  }
  // [head-internal 2026-09-29] Office the resident FORM creates the resident in. An internal
  // referral of another office (head office acting on its behalf): the owning office.
  formTargetOffice(): number {
    const owner = Number(this.data?.selectedRecord?.actingForOfficeID || 0);
    return owner > 0 ? owner : this.residentTargetOffice();
  }
  // "Create new resident" is possible when this office admits, or another
  // selected facility's office is available for the resident.
  canCreateNewResident(): boolean {
    return !this.providerOptions.length || (this.selectedProviders().length > 0 && this.residentOffices().length > 0);
  }

  // Guard used before any accept path: facilities chosen, none re-sent.
  private guardProviders(): boolean {
    if (this.allAlready()) {
      this.toastr.warning('Every facility on this referral is already Accepted — nothing new to send.', '', { timeOut: 3500 });
      return false;
    }
    if (!this.canSubmitProviders()) {
      this.toastr.warning('Select at least one facility this Accept applies to.', '', { timeOut: 3000 });
      return false;
    }
    return true;
  }



  getFileManagerDetails() {
    var ReqModel = {
      fileManagerItemID: this.documentId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.settingsService.GetFileManagerFileDetail(ReqModel).subscribe(async (response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {

          if (this.responseHolder.data.documentData != null) {
            var documentdata: any;
            this.systemFeildsList = [];
            documentdata = JSON.parse(this.responseHolder.data.documentData);
            if (documentdata.length > 0) {
              documentdata.forEach((e) => {
                var obj = {
                  id: this.randomId(),
                  fieldID: e.FieldID,
                  fieldName: e.FieldName,
                  formFieldName: e.Key,
                  value: e.Value,
                  colorCode: e.Key ? '#47e309' : '',
                };
                this.systemFeildsList.push(obj);
              });
            }
          }
          //this.showAddCore = !this.showAddCore;
          //this.dialog.closeAll();
          //this.close();                  
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  randomId() {
    return Math.random();
  }

  selctCore(event: any, row: any) {
    this.showAddButton = false;
    this.transactionID = row.coreID;
  }

  updateRecord() {
    // this.dialogRef.close();
    this.mainModuleNameForDetails = "Core";
    this.vieworUpdate = "View";
    this.showDetail = !this.showDetail;
    // this.acceptReferral();
  }



  getCloseDetails(message) {
    this.showDetail = false;
  }

  acceptReferral() {
    const emails: string[] = this.addUpdateParticipantList?.map(x =>
     x.email?.trim()).filter(email => !!email) || [];

    var ReqModel = {
      referralD: this.referralD,
      coreID: this.transactionID,
      message: this.textForPerson + "<br><br>" + this.message?.trim(),
      emails: emails,
      locationID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      // Portal parity with the plain Accept dialog (2026-09-24): external rows push the
      // Accept to the hospital portal when the user's sync is ON (the API decides and
      // answers "Flowtrics only" when it is off). The typed message is the plain portal
      // text; no provider picker here → the API targets this office's own facility.
      pushToSource: !!this.data?.selectedRecord?.isExternal,
      portalMessage: (this.message || '').trim(),
      targetProviders: this.targetProviders()
    };
    this.loaderService.show();
    this.settingsService.acceptReferralQueue(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.toastr.success('Selected referral accept successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
          this.toastr.error('Referral accept failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.loaderService.hide();
        this.toastr.error('Referral accept failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }

  acceptReferralForNew(result) {
    const emails: string[] = this.addUpdateParticipantList?.map(x =>
     x.email?.trim()).filter(email => !!email) || [];

    var ReqModel = {
      referralD: Number(this.referralD),
      coreID: Number(result.transactionId),
      message: this.textForPerson + "<br><br>" + this.message?.trim(),
      emails: emails,
      locationID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      // Portal parity with the plain Accept dialog (2026-09-24): external rows push the
      // Accept to the hospital portal when the user's sync is ON (the API decides and
      // answers "Flowtrics only" when it is off). The typed message is the plain portal
      // text; no provider picker here → the API targets this office's own facility.
      pushToSource: !!this.data?.selectedRecord?.isExternal,
      portalMessage: (this.message || '').trim(),
      targetProviders: this.targetProviders()
    };
    this.loaderService.show();
    this.settingsService.acceptReferralQueue(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.toastr.success('Selected referral accept successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
          this.toastr.error('Referral accept failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.loaderService.hide();
        this.toastr.error('Referral accept failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }

  referralAccepted(result) {
    this.acceptReferral();
    this.dialogRef.close("RecordUpdated");
  }

  // Decoupled admission (same option as the plain accept dialog): accept the
  // referral WITHOUT linking or creating a resident. The row lands in Accepted
  // and gets a "Create Resident" action for later.
  mfDeferred = MULTIFACILITY_DEFERRED_ADMISSION;
  acceptOnly() {
    if (!this.guardProviders()) return;
    const emails: string[] = this.addUpdateParticipantList?.map(x =>
      x.email?.trim()).filter(email => !!email) || [];
    const ReqModel = {
      referralD: Number(this.referralD),
      // "Accept only" = NO resident: a previously linked one is unlinked (2026-09-26 —
      // re-sending the old id kept a stale/deleted resident attached).
      coreID: 0,
      message: this.textForPerson + "<br><br>" + this.message?.trim(),
      emails: emails,
      locationID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      // Portal parity with the plain Accept dialog (2026-09-24): external rows push the
      // Accept to the hospital portal when the user's sync is ON (the API decides and
      // answers "Flowtrics only" when it is off). The typed message is the plain portal
      // text; no provider picker here → the API targets this office's own facility.
      pushToSource: !!this.data?.selectedRecord?.isExternal,
      portalMessage: (this.message || '').trim(),
      targetProviders: this.targetProviders()
    };
    this.loaderService.show();
    this.settingsService.acceptReferralQueue(ReqModel).subscribe((response) => {
      this.loaderService.hide();
      this.responseHolder = response;
      if (response != undefined && this.responseHolder.status == this.statusConst.statusSuccess) {
        this.toastr.success('Referral accepted — create the resident later from the Accepted list.', '', { timeOut: 3500 });
        this.dialogRef.close("RecordUpdated");
      } else {
        this.toastr.error(this.responseHolder?.message || 'Referral accept failed.', '', { timeOut: 3000 });
      }
    }, () => {
      this.loaderService.hide();
      this.toastr.error('Referral accept failed.', '', { timeOut: 3000 });
    });
  }

  createNew() {
    this.searchName = this.referralName;
    this.mainModuleName = 'Core';
    var menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    var Module = menuModulesList.filter((x) => x.mainModuleName == "Core");
    var Modulename = Module[0].orgModuleName;
    this.Module = Modulename;
    this.showAddCore = !this.showAddCore;

    this.message;
    this.addUpdateParticipantList;
  }

  getselectedTransactionId(result) {
    // Resident created under ANOTHER facility's office: accept with no resident
    // on this row, then attach the new resident to that facility.
    if (this.residentTargetOffice() > 0) {
      this.acceptThenAttach(result);
      return;
    }
    this.acceptReferralForNew(result);
    this.dialogRef.close("RecordUpdated");
  }

  private acceptThenAttach(result: any) {
    const office = this.residentTargetOffice();
    const emails: string[] = this.addUpdateParticipantList?.map(x =>
      x.email?.trim()).filter(email => !!email) || [];
    const acceptReq = {
      referralD: Number(this.referralD),
      coreID: 0,
      message: this.textForPerson + "<br><br>" + this.message?.trim(),
      emails: emails,
      locationID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      pushToSource: !!this.data?.selectedRecord?.isExternal,
      portalMessage: (this.message || '').trim(),
      targetProviders: this.targetProviders()
    };
    const attachReq = {
      referralD: Number(this.referralD),
      coreID: Number(result.transactionId),
      targetOfficeID: office,
      dob: result.dob || null,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID
    };
    this.loaderService.show();
    this.settingsService.acceptReferralQueue(acceptReq).subscribe((response) => {
      this.responseHolder = response;
      if (response == undefined || this.responseHolder.status != this.statusConst.statusSuccess) {
        this.loaderService.hide();
        this.toastr.error(this.responseHolder?.message || 'Referral accept failed.', '', { timeOut: 3000 });
        return;
      }
      this.formsService.attachResidentToReferral(attachReq).subscribe((r: any) => {
        this.loaderService.hide();
        if (r?.status == this.statusConst.statusSuccess && r?.data) {
          this.toastr.success(`Referral accepted — resident created in ${this.residentOfficeName()} and linked to ${this.residentFacilityName()}.`, '', { timeOut: 4000 });
        } else {
          this.toastr.warning(r?.message || 'Referral accepted, but the resident could not be linked to the facility.', '', { timeOut: 5000 });
        }
        this.dialogRef.close("RecordUpdated");
      }, () => {
        this.loaderService.hide();
        this.toastr.warning('Referral accepted, but the resident could not be linked to the facility.', '', { timeOut: 5000 });
        this.dialogRef.close("RecordUpdated");
      });
    }, () => {
      this.loaderService.hide();
      this.toastr.error('Referral accept failed.', '', { timeOut: 3000 });
    });
  }

  getClose(message) {
    this.showAddCore = message;
  }



  addUpdateParticipantList: any = [] = []; 
  emailAssigned: string = '';
  addEmailButtonShow: boolean = false;
  textButton:string="Accept";
  message:string="";

  removeParticipant(item: any) {
    const index = this.addUpdateParticipantList.indexOf(item);
    if (index >= 0) {
      this.addUpdateParticipantList.splice(index, 1);
    }
    if (this.addUpdateParticipantList.length > 0) {
      //this.showAddButton = false;
      this.textButton="Accept & Send Mail";
    } else {
      //this.showAddButton = true;
      this.textButton="Accept";
    }
  }


  //==== For Add Email================//

  addEmail() {
    var check = [];
    check = this.addUpdateParticipantList.filter((x:any) => x.email.toLowerCase() == this.emailAssigned.toLowerCase())

    let toArray = this.emailAssigned.split("@");
    var shortName = toArray[0].match(/\b(\w)/g).join('');
    if (check.length == 0) {
      var obj = {
        name: "",
        email: this.emailAssigned,
        img: "",
        shortName: shortName
      }
      this.addUpdateParticipantList.push(obj);
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      if (this.addUpdateParticipantList.length > 0) {
       // this.showAddButton = false;
        this.textButton="Accept & Send Mail";
      } else {
       // this.showAddButton = true;
        this.textButton="Accept";
      }
    } else {
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      this.toastr.warning('Email allready added.', '', {
        timeOut: 3000,
      });
    }
  }

  emailCheck(searchValue: any) {
    if (searchValue.toLowerCase() == searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
      this.emailAssigned = searchValue;
      this.addEmailButtonShow = true;
    } else {
      this.addEmailButtonShow = false;
    }
  }

}
